export const ATTRIBUTE_MODELS = [
  { id: 3, key: 'OPPORTUNITY' },
  { id: 1, key: 'CONTACT' },
  { id: 0, key: 'CONVERSATION' },
];

// Tipos base
export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 5, key: 'DATE' },
  { id: 11, key: 'FILE' },
  // Variantes de texto
  { id: 8, key: 'TEXT_AREA' },
  { id: 15, key: 'EMAIL' },
  { id: 4, key: 'LINK' },
  // Variantes de número
  { id: 2, key: 'CURRENCY' },
  { id: 3, key: 'PERCENT' },
  { id: 10, key: 'PHONE' },
  { id: 16, key: 'CPF' },
  { id: 17, key: 'CNPJ' },
  // Tipos de lista
  { id: 6, key: 'LIST' },
  { id: 12, key: 'MULTI_LIST' },
  { id: 9, key: 'TEXT_LIST' },
  { id: 18, key: 'TEXT_LIST_AREA' },
  // Tipos de seleção
  { id: 7, key: 'CHECKBOX' },
  { id: 13, key: 'MULTI_CHECKBOX' },
  { id: 14, key: 'RADIO' },
];

// Tipos cujo formulário exibe o editor de opções (OptionListEditor)
export const IDS_WITH_OPTIONS = [6, 9, 12, 13, 14, 18];
